import { useQuery } from '@tanstack/react-query'
import apiClient from '@/api/client'
import { resolveKitchenFlowGate, type KitchenFlowGate } from '@/hooks/useKitchenFlowEnabled'

/**
 * Trade accounts (F-TRD-N1): backend env `FEATURE_TRADE_ACCOUNTS=1`, surfaced
 * as the server-injected `feature_trade_accounts` key on GET /settings. The
 * sidebar row and the page render only when this is exactly true; a missing
 * key or failed fetch reads as off. Same gate semantics and shared cache as
 * the kitchen flow and payroll gates.
 */
export function useTradeAccountsGate(): KitchenFlowGate {
  const { data, status, fetchStatus, refetch } = useQuery({
    queryKey: ['settings', 'all'],
    queryFn: () => apiClient.getAllSettings(),
    staleTime: Infinity,
  })
  const all = data?.data as Record<string, unknown> | undefined
  return {
    ...resolveKitchenFlowGate({ flag: all?.feature_trade_accounts, status, fetchStatus }),
    retry: () => void refetch(),
  }
}

export function useTradeAccountsEnabled(): boolean {
  return useTradeAccountsGate().enabled
}
